import { render } from "./PersonalAccount.vue?vue&type=template&id=71962a6e"
import script from "./PersonalAccount.vue?vue&type=script&lang=js"
export * from "./PersonalAccount.vue?vue&type=script&lang=js"

import "./PersonalAccount.vue?vue&type=style&index=0&id=71962a6e&lang=scss"

import exportComponent from "/var/www/sanremo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__